var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-content',{staticClass:"ion-padding",attrs:{"id":"app"}},[_c('AddTag'),_c('ListTags')],1)}
var staticRenderFns = []

export { render, staticRenderFns }